export default __webpack_public_path__ + "assets/images/load-icon-1c63a43d.svg";